import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Alert, Col, Layout, Row} from 'antd';
import {MenuOutlined, WarningOutlined} from '@ant-design/icons';

import {useGetJails, useHasJail} from '../hooks/useGetJails';
import HeaderDropdown from '../components/HeaderDropdown';
import MembershipHeader from '../containers/staff/MembershipHeader';
import {migratedToV7IndicationBanner} from '../helpers/text';
import {getLogo} from '../helpers/misc';
import {useAppSelector} from '../hooks/useStore';
import {selectAccountMembershipNumber} from '../store/slices/userSlice';
import {Profile} from '../types/accountTypes';

import './EngageHeader.less';

const {Header} = Layout;
const logo = getLogo();

interface EngageHeaderProps {
    toggleSideMenu: () => void;
    mobileMode: boolean;
    isStaff: boolean;
    profile?: Profile;
}

const EngageHeader = ({toggleSideMenu, mobileMode, isStaff, profile}: EngageHeaderProps) => {
    const navigate = useNavigate();
    const memberNumber = useAppSelector(selectAccountMembershipNumber);
    const legacyAccountNumber = profile?.account?.legacy_account_number;
    const [isMigrated] = useHasJail({isStaff, profile, jailName: 'data pushed to v7'});
    const {jails} = useGetJails({isStaff, profile});

    const [showHamburgerIcon, setShowHamburgerIcon] = React.useState(false);

    React.useEffect(() => {
        setShowHamburgerIcon(mobileMode);
    }, [mobileMode]);

    return (
        <Header className="engage-header-wrapper">
            <Row className="full-height-row">
                <Col xs={4} md={1}>
                    {showHamburgerIcon && (
                        <div className="sider-trigger-container" onClick={toggleSideMenu}>
                            <MenuOutlined/>
                        </div>
                    )}
                </Col>
                <Col xs={10} md={0}>
                    {!mobileMode && (
                        <div className="header-logo-container">
                            <img src={logo} className="header-logo" alt="logo"/>
                        </div>
                    )}
                </Col>
                <Col xs={10} sm={4} md={23}>
                    <div className="header-right">
                        {memberNumber && jails.length > 0 && (
                            <WarningOutlined
                                className="warning-icon"
                                onClick={() => navigate('/account/account_info', {state: {activeKey: 3}})}
                            />
                        )}
                        {
                            isStaff && <MembershipHeader memberNumber={memberNumber ?? ''}/>
                        }
                        <HeaderDropdown/>
                    </div>
                </Col>
            </Row>
            {isMigrated && (
                <Alert
                    showIcon
                    banner={true}
                    type="warning"
                    className="migrated-to-v7-banner"
                    message={migratedToV7IndicationBanner(legacyAccountNumber, mobileMode)}
                    onClick={() => navigate('/account/account_info', {state: {activeKey: 3}})}
                />
            )}
        </Header>
    );
}

export default EngageHeader;
